import { useQuery } from '@tanstack/react-query';
import { App, Card, Divider, Table, DatePicker, Flex, Select } from 'antd';
import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { getStockBalance } from '../../network/stockBalanceReport';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getSearchApi } from '../../network/itemList';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const StockBalanceReport = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().format('YYYY-MM-DD'),
    to_date: dayjs().add(1, 'month').format('YYYY-MM-DD'),
    warehouse: '',
    item_code: '',
    stock_uom: '',
  });
  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getStockBalance,
      currentLang,
      sourceData.from_date,
      sourceData.to_date,
      sourceData.warehouse,
      sourceData.item_code,
      sourceData.stock_uom,
    ],
    queryFn: () =>
      getStockBalance(
        currentLang,
        companyName,
        sourceData.from_date,
        sourceData.to_date,
        sourceData.warehouse,
        sourceData.item_code,
        sourceData.stock_uom
      ),
    // enabled: sourceData.from_date && sourceData.to_date,
  });
  const { data: Warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouseSearch],
    queryFn: () => getSearchApi('Warehouse'),
    keepPreviousData: true,
  });
  const { data: items } = useQuery({
    queryKey: [queryKeys.getItemsSearch],
    queryFn: () => getSearchApi('Item'),
    keepPreviousData: true,
  });
  const { message } = App.useApp();

  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col.label,
    dataIndex: col.fieldname,
    key: col.fieldname,
    // width: col.width,
  }));

  const dataSource = stockBalanceDetails?.message?.result
    ?.slice(0, -1)
    ?.map((item, index) => ({
      key: index,
      ...item,
    }));

  const totalRow = stockBalanceDetails?.message?.result?.slice(-1)[0];

  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.inventory} subTitle={t.stockBalance} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Flex
          style={{
            // justifyContent: 'space-between',
            gap: '20px',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <RangePicker
            format="YYYY/MM/DD"
            style={{ width: '100%' }}
            placeholder={['From Date', 'To Date']}
            defaultValue={[dayjs(), dayjs().add(1, 'month')]}
            onChange={(dates, dateStrings) => {
              setSourceData({
                from_date: dateStrings[0],
                to_date: dateStrings[1],
              });
            }}
          />
          <Select
            placeholder={t.items}
            showSearch
            popupMatchSelectWidth={false}
            style={{ width: '100%' }}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={items?.message?.map((item) => ({
              value: item?.value,
              label: item?.value,
            }))}
            onChange={(value) => {
              setSourceData({
                ...sourceData,
                item_code: value,
              });
            }}
          />
          <Select
            placeholder={t.warehouse}
            showSearch
            popupMatchSelectWidth={false}
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={Warehouse?.message?.map((item) => ({
              value: item?.value,
              label: item?.value,
            }))}
            style={{ width: '100%' }}
            onChange={(value) => {
              setSourceData({
                ...sourceData,
                warehouse: value,
              });
            }}
          />
          {/* <h3>{t.StockBalanceList}</h3> */}
        </Flex>
        <Divider orientation="left">{t.StockBalanceList}</Divider>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          summary={() => (
            <Table.Summary.Row>
              {totalRow?.map((value, index) => (
                <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
              ))}
            </Table.Summary.Row>
          )}
        />
      </Card>
    </div>
  );
};

export default StockBalanceReport;
